package com.essntl.uikit.components.input.placeholder

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.uikit.theme.esTypography

@Composable
fun EsInputPlaceholder(
    label: String,
    modifier: Modifier = Modifier,
) {
    Text(
        text = label,
        maxLines = 1,
        style = MaterialTheme.esTypography.p1Regular16,
        modifier = modifier,
    )
}